import { Injectable } from '@angular/core';

import { config } from '../../environments/environment';
import { ContentfulService } from './contentful.service';
import { Router,NavigationEnd  } from '@angular/router';
import { filter, finalize, of, BehaviorSubject, Observable } from 'rxjs';
export interface Config {
  ApiUrl: string;
  isEntraEnabled?: boolean;
  trialAPIConnectionProfile: {
    connectionName: string;
    apiURI: string;
    clientKey: string;
    agencyName: string;
    iata: string;
    contactEMail: string;
    corporateSenderDetails: {
      corporateSender: false;
      directCorporate: false;
    };
    corporateID: string;
    tmcDetails: {
      includeAggregator: boolean;
    };
    aggregatorName: string;
    aggregatorID: string;
    orderChangeNotifCredentials: {
      ocnuid: string;
      ocnpwd: string;
    };
  };
  apiConnectionProfileURIs: {
    api_id: string;
    api_uri: string;
  }[];
  maxNumberOfAPIConnectionProfiles: number;
  contact: {
    addressContact: {
      street1: string;
      street2: string;
      cityName: string;
      postalCode: string;
      countryCode: string;
    };
  };
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  BA_LOGO_MAP = new Map();
  private isEntraEnabledSubject = new BehaviorSubject<boolean>(true);
  private loginPopup: any;
  private configPromise: Promise<void> | null = null;

  private config: Config = {
    ApiUrl: '',
    apiConnectionProfileURIs: [
      {
        api_id: 'Trial',
        api_uri: '/test/trial/selling-distribution'
      },
      {
        api_id: 'Pre-Live',
        api_uri: '/test/selling-distribution'
      },
      {
        api_id: 'Beta',
        api_uri: '/test/selling-distribution'
      },
      {
        api_id: 'Live',
        api_uri: '/live/selling-distribution'
      },
      {
        api_id: 'Custom',
        api_uri: '/test/selling-distribution/'
      }
    ],
    trialAPIConnectionProfile: {
      iata: '00000162',
      apiURI: 'Trial',
      clientKey: '',
      agencyName: 'NDC AGENT',
      tmcDetails: {
        includeAggregator: true
      },
      corporateID: '',
      aggregatorID: '00000140',
      contactEMail: 'ndc@ba.com',
      aggregatorName: 'NDC Aggregator',
      connectionName: 'TRIAL',
      corporateSenderDetails: {
        corporateSender: false,
        directCorporate: false
      },
      orderChangeNotifCredentials: {
        ocnpwd: '',
        ocnuid: ''
      }
    },
    maxNumberOfAPIConnectionProfiles: 30,
    contact: {
      addressContact: {
        street1: 'TESTT ADDR1',
        street2: 'TESTT ADDR2',
        cityName: 'LON',
        postalCode: '120000',
        countryCode: 'GB'
      }
    }
  };

  constructor(private contentfulService: ContentfulService, private router: Router) {
    this.loadConfig();
  }

  private loadConfig() {
    if (this.configPromise) return;
    
    this.configPromise = Promise.all([
      this.loadNDCConfig(),
      this.loadLogos(),
      this.loadLoginPopup()
    ]).then(() => {}).catch(() => {});
  }

  private async loadNDCConfig() {
    const query = { 'fields.name': config.environmentName + '#CONFIG#NDC' };
    try {
      const items = await this.contentfulService.getMenuContentWithItems(query);
      this.handleConfigResponse(items);
    } catch (error) {
      console.error('Failed to load config from Contentful:', error);
    }
  }

  private handleConfigResponse(items: any) {
    if (items && items[0]?.fields?.jsonData) {
      const contentfulData = items[0].fields.jsonData;
      this.config = { ...this.config, ...contentfulData };
    }
  }

  private async loadLogos() {
    const logo_query = { 'fields.name': 'BA_LOGOS' };
    try {
      const items = await this.contentfulService.getMenuContentWithItems(logo_query);
      this.handleLogosResponse(items);
    } catch (error) {
      console.error('Failed to load logos from Contentful:', error);
    }
  }

  private handleLogosResponse(items: any) {
    if (items && items[0]?.fields?.jsonData) {
      const baLogos: [] = items[0].fields.jsonData;
      if (baLogos && Object.keys(baLogos).length > 0) {
        Object.entries(baLogos).forEach(([key, value]) => {
          this.BA_LOGO_MAP.set(key, value);
        });
      }
    }
  }

  private async loadLoginPopup() {
    const query = { 'fields.name': 'LOGIN_POPUP' };
    try {
      const items = await this.contentfulService.getMenuContentWithItems(query);
      this.handleLoginPopupResponse(items);
    } catch (error) {
      console.error('Failed to load login popup from Contentful:', error);
    }
  }

  private handleLoginPopupResponse(items: any) {
    if (items && items[0]?.fields?.jsonData) {
      this.loginPopup = items[0].fields.jsonData;
    }
  }

  async waitForConfig(): Promise<void> {
    if (!this.configPromise) this.loadConfig();
    await Promise.race([
      this.configPromise,
      new Promise(resolve => setTimeout(resolve, 5000))
    ]);
  }

  getLoginPopup(): any {
    return this.loginPopup;
  }

  getConfig(): Config {
    return this.config;
  }

  getLogo(key: string): string {
    return this.BA_LOGO_MAP.get(key);
  }

  getIsEntraEnabled(): Observable<boolean> {
    return this.isEntraEnabledSubject.asObservable();
  }

}
